import { library } from '@fortawesome/fontawesome-svg-core'

import { faFolders } from '@fortawesome/pro-solid-svg-icons/faFolders'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock'
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil'
import { faBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import { faEuroSign } from '@fortawesome/pro-solid-svg-icons/faEuroSign'
import { faPercentage } from '@fortawesome/pro-solid-svg-icons/faPercentage'
import { faAlarmExclamation } from '@fortawesome/pro-solid-svg-icons/faAlarmExclamation'

import { faArrowsAltV } from '@fortawesome/pro-regular-svg-icons/faArrowsAltV'

library.add(
  faFolders, faTimes, faPlusCircle, faClock, faPencil,
  faBuilding, faUser, faEuroSign, faPercentage, faAlarmExclamation,
  faArrowsAltV
)
